import React from 'react';
import { Typography, IconButton, Grid } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { formatSpeed } from './Broadband.util';

const BroadbandPrequalTopTag = ({ date, speed, setShowPrequalTopTag }) => {
  const theme = useTheme();
  const formatDate = futureDate => {
    const objectDate = new Date(futureDate.toString());
    const day = objectDate.getDate();
    const month = objectDate.getMonth() + 1;
    const year = objectDate.getFullYear();

    return `${day}/${month}/${year}`;
  };

  return (
    <Grid item container xs={12}>
      <Grid item xs={11}>
        <Typography
          sx={{
            marginInline: 'auto',
            lineHeight: 2.5,
            color: theme.palette.secondary.OfferSelected,
          }}
        >
          Your home will be eligible for speeds of up to {formatSpeed(speed)}from{' '}
          <strong>{formatDate(date)}</strong>
        </Typography>
      </Grid>
      <Grid item xs={1}>
        <IconButton sx={{ marginRight: 0, color: theme.palette.primary.OfferSelected }}>
          <CloseOutlinedIcon
            onClick={() => {
              setShowPrequalTopTag(false);
            }}
          />
        </IconButton>
      </Grid>
    </Grid>
  );
};

export default BroadbandPrequalTopTag;
